import { useEventContext } from 'contexts';

export const EventLink = () => {
    const event = useEventContext();

    return (
        <>
            {!!event?.event_site_url && (
                <a className="event-link" href={event.event_site_url!} target="_blank" rel="noopener noreferrer">
                    {event.name}
                </a>
            )}
        </>
    );
};
